export enum WorkflowStageType {
    Basics,
    DataIngestion,
    Transformation,
    Publish,
    Merge,
    Consume
    
}